// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"6292575d","710":"53bd64d5","845":"13c5f91d"}[chunkId] + ".chunk.js";
};